import apiClient from '../../services/common/apiClient';

interface DownloadMovieProps {
    url: string;
    onSuccess: () => void;
    onError: () => void;
}
export const downloadMovie = async ({
    url,
    onSuccess,
    onError,
}: DownloadMovieProps) => {
    // 5 minutes - max wait
    const interval = 5000;
    const maxRetries = 60;
    apiClient
        .sendWithRetry(
            {
                url,
                method: 'HEAD',
            },
            maxRetries,
            interval
        )
        .then(() => {
            const link = document.createElement('a');
            document.body.appendChild(link);
            link.style.display = 'none';
            link.href = url;
            link.click();
            if (link.parentNode) {
                link.parentNode.removeChild(link);
            }
            onSuccess();
        })
        .catch(() => onError());
};
export default downloadMovie;
